class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (!element) return;

      const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (html == null) return;

      /*
       * Angleichen statt ersetzen (assets/dom-morph.js). Beim Hinzufuegen aus
       * dem Drawer heraus bleiben dadurch die Zeilen stehen, die sich nicht
       * geaendert haben — sonst laegen alle Produktbilder kurz als graue
       * Platzhalter da und die Scrollposition sprang zurueck.
       */
      if (window.theme && typeof theme.morph === 'function') {
        theme.morph(element, html);
      } else {
        element.innerHTML = html;
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

/* Der Versandhinweis ueber dem Balken sah aus wie ein Link und war keiner:
   Clarity hat im Drawer konstant tote Taps darauf gezaehlt. Jetzt springt der
   Tap auf die Empfehlungen im Drawer, damit der Kunde sein Set dort
   weiterbaut statt zurueck in den Shop zu gehen. Stehen keine Empfehlungen da
   (leerer Block, alles schon im Warenkorb), oeffnet er die Kollektion aus
   data-fallback-url. Markup: snippets/free-shipping.liquid. */
class FreeShippingJump extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick() {
    const drawer = this.closest('#mini-cart') || document;
    const recommendations = drawer.querySelector('.cart-recommendations');

    if (recommendations && recommendations.querySelector('li')) {
      recommendations.scrollIntoView({ behavior: 'smooth', block: 'center' });

      /* Kurz aufblitzen, sonst ist nach dem Scrollen nicht klar, worauf der
         Tap gezeigt hat. Klasse erst weg und ein Reflow dazwischen, damit die
         Animation beim zweiten Tap wieder von vorne laeuft. */
      recommendations.classList.remove('is-flashing');
      void recommendations.offsetWidth;
      recommendations.classList.add('is-flashing');
      return;
    }

    const url = this.dataset.fallbackUrl;
    if (url) window.location.href = url;
  }
}
customElements.define('free-shipping-jump', FreeShippingJump);
